import type { LanguageKeyMap } from '$/store/languageStore/smartcatTranslation';

/**
 * 资产列表「任务类型」筛选：`AssetListParams.task_type` 的可选值（`all` 为前端聚合项）。
 */
export type AssetListTaskTypeFilterValue =
  | 'all'
  | 'agent-team'
  | 'agent'
  | 'workflow'
  | 'tool';

/**
 * 资产列表任务类型筛选项（`labelKey` 对应 smartcat `zh.json`，展示时经 `smartcatTranslationText` 解析）。
 */
export interface AssetListTaskTypeFilterOption {
  value: AssetListTaskTypeFilterValue;
  labelKey: keyof LanguageKeyMap;
  icon: string;
}

/**
 * 资产列表任务类型筛选项：顺序、文案与图标（Figma RoboNeo-Web 33766:107498）。
 * 供资产页、画布资产弹窗等共用。
 */
export const ASSET_LIST_TASK_TYPE_FILTER_OPTIONS: readonly AssetListTaskTypeFilterOption[] = [
  { value: 'all', labelKey: 'alltasks', icon: 'squareGridCircleBold' },
  { value: 'agent-team', labelKey: 'roboneo_agent_teams', icon: 'userGroupBold' },
  { value: 'agent', labelKey: 'canvas', icon: 'newCanvaBold' },
  { value: 'workflow', labelKey: 'workflow', icon: 'newWorkFlowBold' },
  { value: 'tool', labelKey: 'tools', icon: 'magicWandBold' },
];
